import { SearchOutlined } from "@ant-design/icons";
import { Checkbox, Collapse, Spin } from "antd";
import Search from "antd/lib/input/Search";
import React from "react";
import { DocumentStatus } from "../../../core/common/Constants";

import { TTranslate } from "../../../core/service/locale/TranslationService";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { TOrganisationIndexTreeItem } from "../../../organisations/presenter/model/OrganisationIndexTreePresentationModel";
import { IUser } from "../../../user/model/User";
import { FILTER_START_YEAR } from "../../common/Constants";
import { TSearchCriteriaFilter } from "../../model/SearchCriteria";
import { TFacetCollection } from "../../model/SearchResponse";
import { TSearchQueryRequest } from "../../service/SearchService";
import IndexSelectionTree from "./criteria/IndexSelectionTree";
import OrganisationCheckboxGroup from "./criteria/OrganisationCheckboxGroup";
import YearList from "./criteria/YearList";

const { Panel } = Collapse;
let statusList = [
  {
    label: "U pripremi",
    key: DocumentStatus.IN_PROGRESS
  },
  {
    label: "Evidentiran",
    key: DocumentStatus.RECORDED
  },
  {
    label: "Verifikovan",
    key: DocumentStatus.VERIFIED
  },
  {
    label: "Objavljen",
    key: DocumentStatus.PUBLISHED
  },
  {
    label: "Arhiviran",
    key: DocumentStatus.ARCHIVED
  },
  {
    label: "Invalidiran",
    key: DocumentStatus.INVALIDATED
  }
];
const SearchCriteriaForm = ({
  translate,
  organisations,
  facets,
  onUpdateCriteria,
  selectedYears,
  selectedDecisionYears,
  selectedOrganisations,
  selectedIndexTypes,
  indexTrees,
  indexLoading,
  organisationsLoading,
  showStatusFilter,
  selectedDocumentStatuses,
  removeSelectedDate,
  searchQuery,
  user
}: {
  translate: TTranslate;
  organisations: IOrganisation[];
  facets?: TFacetCollection;
  onUpdateCriteria?(query: TSearchCriteriaFilter): any;
  selectedYears?: string[];
  selectedDecisionYears?: string[];
  selectedOrganisations?: string[];
  selectedIndexTypes?: string[];
  selectedDocumentStatuses?: string[];
  indexTrees?: TOrganisationIndexTreeItem[][];
  indexLoading?: boolean;
  organisationsLoading?: boolean;
  showStatusFilter: boolean;
  removeSelectedDate?: any;
  searchQuery?: TSearchQueryRequest;
  user?: IUser;
}) => {
  let years: number[] = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= FILTER_START_YEAR; i--) {
    years.push(i);
  }
  let organisationFacets = facets?.["organisation_name_facet"];
  let yearFacets = facets?.["year"];
  let decisionDateFacets = facets?.["decision_date_dt"];
  let indexFacets = facets?.["index_id_is"];
  let statusFacets = facets?.["status"];

  return (
    <>
      <p className={"dashboard-sider-block-title"}>
        <SearchOutlined className={"dashboard-sider-block-icon"} />{" "}
        {translate("editors.case_law_documents.filter")}
      </p>
      <Collapse
        defaultActiveKey={["1", "2", "3", "4", "5", "6"]}
        ghost
        bordered
      >
        {false && (
          <Panel header={translate("search.sider.by_organisation")} key="4">
            <div style={{ marginLeft: 28 }}>
              <OrganisationCheckboxGroup
                organisations={organisations}
                organisationFacets={organisationFacets}
                selectedOrganisations={selectedOrganisations}
                translate={translate}
                loading={organisationsLoading}
                showFacetCount
                onChange={(list) => {
                  onUpdateCriteria?.({
                    organisation: list?.join(",")
                  });
                }}
              />
            </div>
          </Panel>
        )}
        <Panel header={translate("search.sider.by_index")} key="3">
          <div style={{ marginLeft: 10 }}>
            <IndexSelectionTree
              translate={translate}
              facet={indexFacets}
              loading={indexLoading || false}
              selectedIndexTypes={selectedIndexTypes}
              indexTrees={indexTrees || []}
              onCheck={(list) =>
                onUpdateCriteria?.({
                  index: list?.filter((e) => e).join(",")
                })
              }
              showFacetCount
            />
          </div>
        </Panel>
        <Panel header={translate("search.sider.by_decision_date")} key="6">
          <div style={{ marginLeft: 10 }}>
            <YearList
              selectedYears={selectedDecisionYears}
              years={years}
              facet={decisionDateFacets}
              onSelect={(value) => onUpdateCriteria?.({ decision_date: value })}
              removeSelected={removeSelectedDate}
              property={"decision_date"}
              searchQuery={searchQuery}
              translate={translate}
            />
          </div>
        </Panel>
        {showStatusFilter && (
          <Panel header={translate("search.sider.by_status")} key="5">
            <div style={{ marginLeft: 28 }}>
              <Checkbox.Group
                value={selectedDocumentStatuses}
                onChange={(value) =>
                  onUpdateCriteria?.({
                    status: value.join(",")
                  })
                }
              >
                {statusList.map((item, index) => {
                  if (
                    (item.key === DocumentStatus.IN_PROGRESS &&
                      user &&
                      user.isSuperAdmin()) ||
                    item.key !== DocumentStatus.IN_PROGRESS
                  ) {
                    return (
                      <div
                        style={{ marginBottom: 4 }}
                        key={`document-status-${index}`}
                      >
                        <Checkbox
                          key={`status-check-${index}`}
                          value={item.key}
                        >
                          {`${item.label} (${statusFacets?.[item.key] || "0"})`}
                        </Checkbox>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </Checkbox.Group>
            </div>
          </Panel>
        )}
        <Panel
          header={translate("search.sider.by_key_word")}
          key="1"
          style={{ display: "none" }}
        >
          <div style={{ marginLeft: 10 }}>
            <Search
              placeholder={translate("search.sider.add_key_word")}
              allowClear
              onSearch={() => {}}
              style={{ marginTop: 10 }}
            />
          </div>
        </Panel>

        <Panel header={translate("search.sider.by_year")} key="2">
          <div style={{ marginLeft: 10 }}>
            <YearList
              selectedYears={selectedYears}
              years={years}
              facet={yearFacets}
              onSelect={(value) => onUpdateCriteria?.({ year: value })}
              property={"year"}
              removeSelected={removeSelectedDate}
              searchQuery={searchQuery}
              translate={translate}
            />
          </div>
        </Panel>
      </Collapse>
    </>
  );
};

export default SearchCriteriaForm;
